const successBold = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M15.5 8a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0m-11.793.2 1.082-1.032 2.16 2.246 4.266-4.441 1.078 1.047-5.344 5.57z" clip-rule="evenodd"/></svg>',
};

export { successBold as default };
